import * as React from 'react';
import { getOnlyWeeksOf } from '@services/user/user.utils';
import {connect} from 'react-redux';
import { WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { addDays, toIsoDate } from '@helpers/DateHelper';
import Day from './Day';
import { DayDetailsStyle } from './DayDetails.style';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { IEvent, ILocalEvent } from '@app-types/websocket/event.types';
import { ISchedule } from '@app-types/websocket/schedule.types';
import { ICalendarSetting } from '@app-types/websocket/user.types';
import { IScheduleEvent } from './scheuldeEvent.types';
import EditEvent from '../eventdetails/EditEvent';
import EditScheduleEvent from '../eventdetails/EditScheduleEvent';
import { ITodo} from '@app-types/websocket/todo.types';
import * as EventActions from '@services/events/event.action';
import { FamilyMemberType } from '@services/family/family.constants';
import { holidays as allHolidays } from '../holidays/holidays';
import { IExternalCalenderEvent } from '@app-types/api/externalCalendar.types';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  numDays:number;
  dayRefs:Array<React.RefObject<HTMLDivElement>>;
  topDay:string;
  editTodo:ITodo|undefined;
  addTodoToScheduleId:number|undefined;
  showEditHandoverPosition:"START"|"END";
  sentSeen:number[];
  unseenEvents:IEvent[];
}

interface IProps extends WithStyles<typeof DayDetailsStyle> {
  //   paneRef: React.RefObject<HTMLDivElement>;

  isOnline:boolean;
  schoolAge:number;
  initialDay: Date;
  localization: "se"|"en";
  setSelectedDay: (day:Date) => void;
  isResizing:boolean;
  showEventDetails:number|undefined;
  setShowEventDetails:(event:number|undefined) => void;
  family:IFamilyMember[];
  events:IEvent[];
  localEvents:ILocalEvent[];
  onlyWeeksOf:number|undefined;
  isParent:boolean;
  userId:number;
  scheduleOne:ISchedule|undefined;
  scheduleTwo:ISchedule|undefined;
  scheduleThree:ISchedule|undefined;

  createEventOnDate: (day:Date) => void;
  showEditHandover:IScheduleEvent|undefined;
  setShowEditHandover:(event:IScheduleEvent|undefined) => void;

  externalEventsPerDay:{ [day: string]: IExternalCalenderEvent []}

  todos:ITodo[];
  calendarSettings: ICalendarSetting;
  holidays:{ [key:string]:{title:string, type:"HOLIDAY"|"SPECIAL_DAY"}; };
  seenEvent: (id:number) => void;
  completedEvent: (id:number) => void;
  parents:number[];
  zoomImage: (url:string|undefined) => void;
  // packingLists:{one:IPackingList[],two:IPackingList[],three:IPackingList[]};
}

class WeekView extends React.Component<IProps, IState> {
  private observerTimer:NodeJS.Timeout|null = null;
  private observerResetScroll:boolean = true;

  private observer: IntersectionObserver;
  private paneRef: React.RefObject<HTMLDivElement> = React.createRef();
  private visibleDays:string[] = []
  private scrollAddedMoreDaysTime:number = 0;

  constructor(props: IProps) {
    super(props);

    const dayRefs:Array<React.RefObject<HTMLDivElement>> = []
    for (let index = 0; index < 21; index++) {
      dayRefs.push(React.createRef());
    }
    
    this.state = {

      numDays:21,
      dayRefs,
      topDay:"1970-01-01",
      editTodo:undefined,
      showEditHandoverPosition:"START",
      sentSeen:[],
      addTodoToScheduleId:undefined,
      unseenEvents:props.events.filter((e) => (e.seen && e.startTime >  props.initialDay.getTime()
        && !e.seen.includes(props.userId))),
    };

  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState:Readonly<IState>): void {
    if (this.props.isResizing !== prevProps.isResizing) {
      if (this.props.isResizing && this.observer) {
        this.observer.disconnect();
      } else {
        this.startObservingAfterLoad(false);
      }
    } else if (!this.props.isResizing && (this.props.initialDay !== prevProps.initialDay )) {

      if (this.props.initialDay !== prevProps.initialDay) {
        if (this.paneRef.current) {
          this.paneRef.current.scrollTop = 0;
          this.setState({numDays:21});
        }
      }
      this.startObservingAfterLoad(true);
    }  else if (this.props.isOnline && !prevProps.isOnline) {
      this.startObservingAfterLoad(true);
    } else {
      if (this.observerTimer) {
        this.startObservingAfterLoad(this.observerResetScroll);
      }
    }
    if (this.props.events !== prevProps.events) {
      const unseenEvents = this.props.events.filter((e) => (e.seen && e.endTime >  (this.props.initialDay.getTime() -(1000*60*60*24*14))
        && !e.seen.includes(this.props.userId)))
      this.setState({unseenEvents});
      if (!this.props.isResizing && this.props.isOnline) {
        this.observe();
      }
    }
  }

  public componentDidMount() {
    this.startObservingAfterLoad(true);
  }

  // loading events cause the observer to trigger on ios so we cant start it until we are loaded
  public startObservingAfterLoad(resetScroll:boolean) {
    this.observerResetScroll = resetScroll;
    if (this.observerTimer) {
      clearTimeout(this.observerTimer);
    }
    this.observerTimer = setTimeout(() => {
      if (!this.props.isResizing && this.props.isOnline) {
        if (this.observerResetScroll && this.paneRef.current) {
          this.paneRef.current.scrollTop = 0;
        }
        this.observe();
        this.observerTimer = null;
        this.observerResetScroll = false;
      } else {
        this.startObservingAfterLoad(resetScroll);
      }
    },200)
    
  }

  public render() {
    const {classes, initialDay, localization, family, events, scheduleOne, scheduleTwo, scheduleThree, userId, externalEventsPerDay} = this.props;
    const {numDays, dayRefs} = this.state;

    let spinDate = initialDay;
    const days:JSX.Element[] = [];

    for (let index = 0; index < numDays; index++) {
      days.push(
        <Day
          importedEvents={this.props.localEvents}
          onlyWeeksOf={this.props.onlyWeeksOf}
          isParent={this.props.isParent}
          schoolAge={this.props.schoolAge}
          zoomImage={(url) => this.props.zoomImage(url)}
          externalEvents={externalEventsPerDay[toIsoDate(spinDate)]}
          holidays={this.props.holidays}
          events={events}
          family={family}
          key={index}
          day={spinDate}
          reference={dayRefs[index]}
          localization={localization}
          scheduleOne={scheduleOne}
          scheduleTwo={scheduleTwo}
          scheduleThree={scheduleThree}
          userId={userId}
          todos={this.props.todos}
          seenEvent={(id:number) => this.props.seenEvent(id)}
          completedEvent={(id:number) => this.props.completedEvent(id)}
          addPackingListItem={(sid) => this.setState({addTodoToScheduleId:sid})}
          editTodo={(todo) => this.setState({editTodo:todo})}
          showScheduleDetails={(event:IScheduleEvent|undefined, position:"START"|"END") => 
            {this.props.setShowEditHandover(event); this.setState({showEditHandoverPosition:position})}}
          createEventOnDate={(day) => this.props.createEventOnDate(day)}
          showEventDetails={(event:number|undefined) => this.props.setShowEventDetails(event)}
        />
      );
      spinDate = addDays(spinDate,1);
    }

    let editEvent:IEvent|undefined;
    if (this.props.showEventDetails !== undefined) {
      editEvent = this.props.events.find((ev) => ev.id === this.props.showEventDetails);
    }

    let editPane:JSX.Element|null = null;
    if (this.props.showEventDetails !== undefined) {
      editPane = <EditEvent 
        onDate={undefined}
        event={editEvent}
        close={() => this.props.setShowEventDetails(undefined)}/>;
    } else if (this.props.showEditHandover !== undefined) {
      editPane = <EditScheduleEvent 
        event={this.props.showEditHandover}
        position={this.state.showEditHandoverPosition}
        close={() => this.props.setShowEditHandover(undefined)}/>;
    }

    return (
      
      <div className={classes.daysPane} ref={this.paneRef} onScroll={(e) => this.scrollHandler(e.currentTarget)}
        style={{overflowY:this.props.showEventDetails!== undefined?'hidden':'auto'}}>
          {this.props.children}
          {days}
        <div className={classes.detailsPane} style={((editPane === null)?{transform: 'translateX(100vw)'}:{})}>
          {editPane}
        </div>
      </div>
    );
  }

  private scrollHandler(e:HTMLDivElement) {

    if ((e.scrollHeight - (e.scrollTop+e.clientHeight)) < 500 && Date.now() - this.scrollAddedMoreDaysTime > 500) {
      this.scrollAddedMoreDaysTime = Date.now();
      const dayRefs = [...this.state.dayRefs];
      for (let index = 0; index < 7; index++) {
        dayRefs.push(React.createRef());
      }
      this.setState({numDays:this.state.numDays+7, dayRefs})
      this.startObservingAfterLoad(false);

    }
  }

  private observe() {
    if (this.observer) {
      this.observer.disconnect();
      this.visibleDays = [];
    }

    const container = this.paneRef.current;

    if (container) {

      const options:IntersectionObserverInit = {
        root: container,
        rootMargin: "0px 0px 0px",
        threshold: 1,
      };

      const callback = (entries:IntersectionObserverEntry[], observer:IntersectionObserver) => {
        entries.forEach((entry:IntersectionObserverEntry) => {
          const visibleChildId = entry.target.getAttribute('id');
          if (visibleChildId) {
            if (entry.isIntersecting) {
              this.visibleDays.push(visibleChildId);
            } else {
              this.visibleDays = this.visibleDays.filter((day) => day !== visibleChildId)
            }            
          }
        });
        if (this.visibleDays.length > 0) {
          this.visibleDays.sort((a, b) => a.localeCompare(b));

          const startYearMonthDay = this.visibleDays[0].split("-");
          const endYearMonthDay = this.visibleDays[this.visibleDays.length-1].split("-");
          if (startYearMonthDay.length === 3 && endYearMonthDay.length === 3) {
            const startVisibleDate:Date = new Date(parseInt(startYearMonthDay[0],10),parseInt(startYearMonthDay[1],10),
              parseInt(startYearMonthDay[2],10));
            const endVisibleDate:Date = new Date(parseInt(endYearMonthDay[0],10),parseInt(endYearMonthDay[1],10),
              parseInt(endYearMonthDay[2],10));  

            if (this.visibleDays[0] !== this.state.topDay) {
              this.setState({topDay:this.visibleDays[0]});
              this.props.setSelectedDay(startVisibleDate);
            }

            const startVisibleDateCopy = new Date(startVisibleDate);
            startVisibleDateCopy.setHours(0);
            startVisibleDateCopy.setMinutes(0);
            endVisibleDate.setHours(23);
            endVisibleDate.setMinutes(59);

            const startTimeSee = startVisibleDateCopy.getTime();
            const endTimeSee = endVisibleDate.getTime();

            for (const unseen of this.state.unseenEvents) {
              if ((!this.state.sentSeen.includes(unseen.id)) && (
                  (unseen.startTime > startTimeSee && unseen.startTime < endTimeSee )
                  || (unseen.endTime > startTimeSee && unseen.endTime < endTimeSee )
                  || (unseen.startTime < startTimeSee && unseen.endTime > endTimeSee )
                )) 
              {
                this.props.seenEvent(unseen.id);
                this.setState((prevState) => ({sentSeen:[...prevState.sentSeen, unseen.id]}));
              }
            }
          }
        }

      };

      this.observer = new IntersectionObserver(callback, options);
      for (const dayRef of this.state.dayRefs) {
        const element = dayRef.current;
        if (element) {
          this.observer.observe(element);
        }
      }
    }
  }

}
  


function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  const schedules:ISchedule[] =  state.schedule.schedules;
  const calendarSettings: ICalendarSetting = state.user.calendarSettings;

  let scheduleOne:ISchedule|undefined;
  let scheduleTwo:ISchedule|undefined;
  let scheduleThree:ISchedule|undefined;

  if (calendarSettings !== undefined && calendarSettings.calendars !== undefined) {
    for (const cal of schedules) {
      if (calendarSettings.calendars.length > 0 && cal.id === calendarSettings.calendars[0]) {
        scheduleOne = cal;
      }
      if (calendarSettings.calendars.length > 1 && cal.id === calendarSettings.calendars[1]) {
        scheduleTwo = cal;
      }
      if (calendarSettings.calendars.length > 2 && cal.id === calendarSettings.calendars[2]) {
        scheduleThree = cal;
      }
    }
  }

  const country = (state.user.calendarSettings && state.user.calendarSettings.holidaysCountry)
    ?state.user.calendarSettings.holidaysCountry
    :undefined
  const holidays = allHolidays.getHolidays(country);
  
  const todos:ITodo[] = state.todo.todos?state.todo.todos:[];

  let isParent:boolean = false;
  const parents:number[] = [];
  for (const mem of (state.family.family?state.family.family:[])){
    if (mem.role === FamilyMemberType.PARENT) {
      parents.push(mem.id);
      if (mem.id === userId) {
        isParent = true;
      }
    }
  }

  return {
    userId,
    family: state.family.family,
    events: state.event.events,
    scheduleOne,
    scheduleTwo,
    scheduleThree,
    calendarSettings,
    todos,
    holidays,
    parents,
    isParent,
    onlyWeeksOf: getOnlyWeeksOf(state),
    isOnline:state.connection.loadCompleted,
  };
}

const mapDispatchToProps = {
  seenEvent: EventActions.seenEvent,
  completedEvent: EventActions.completedEvent,
};
export default connect(mapStateToProps,mapDispatchToProps)(withStyles(DayDetailsStyle)(WeekView));



// WEBPACK FOOTER //
// ./src/components/calendar2/dayDetails/WeekView.tsx